import { ApiClientFactory } from "@/clients/ApiClientFactory";

let factory = new ApiClientFactory(process.env.VUE_APP_CENTRAL_API_URL, false);

/**
 *
 * @namespace TenantClient
 */
export const TenantClient = {
  /**
   *
   * Check available tenants for user
   * @param {Object} query
   * @param {?string} query.email
   * @param {?string} query.slug
   * @param {?number} query.id
   * @param {?string} query.uuid
   * @returns {Promise<AxiosResponse<*>>}
   */
  getTenants(query) {
    let queryString = "";
    if (Object.prototype.hasOwnProperty.call(query, "email")) {
      queryString = `email=${query.email}`;
    }
    if (Object.prototype.hasOwnProperty.call(query, "slug")) {
      queryString = `slug=${query.slug}`;
    }
    if (Object.prototype.hasOwnProperty.call(query, "id")) {
      queryString = `id=${query.id}`;
    }
    if (Object.prototype.hasOwnProperty.call(query, "uuid")) {
      queryString = `uuid=${query.uuid}`;
    }

    return factory.get(`/find-tenants?${queryString}`);
  },
};
